import React, { useRef } from "react";
import Select from "react-select";
import { Button, Input, Table } from "reactstrap";

const emptyLine = {
    articleId: "",
    articleCode: "",
    articleLibelle: "",
    prixOriginal: "",
    prixPromo: "",
    barcode: "",
    barcodeType: "EAN13",
    quantiteEtiquettes: 1,
    ordreAffichage: "",
};

const PromotionTicketLines = ({
    values,
    setFieldValue,
    productOptions = [],
    productsLoading = false,
    onProductSearch,
    mode = "promotion",
}) => {
    const tickets = values.tickets || [];
    const promoPriceRefs = useRef([]);
    const isPromotionMode = mode === "promotion";

    const filterProductOption = (option, inputValue) => {
        const normalizedInput = (inputValue || "").trim().toLowerCase();

        if (!normalizedInput) {
            return true;
        }

        return (option.data.searchText || option.label || "")
            .toLowerCase()
            .includes(normalizedInput);
    };

    const handleAddLine = () => {
        setFieldValue("tickets", [
            ...tickets,
            {
                ...emptyLine,
                ordreAffichage: tickets.length + 1,
            },
        ]);
    };

    const handleRemoveLine = (index) => {
        const updated = tickets.filter((_, i) => i !== index);
        setFieldValue("tickets", updated);
    };

    const handleChange = (index, field, value) => {
        const updated = [...tickets];
        updated[index] = {
            ...updated[index],
            [field]: value,
        };
        setFieldValue("tickets", updated);
    };

    const handleProductSelect = (index, selectedOption) => {
        const updated = [...tickets];

        if (!selectedOption?.product) {
            updated[index] = {
                ...updated[index],
                articleId: "",
                articleCode: "",
                articleLibelle: "",
                prixOriginal: "",
                barcode: "",
            };
            setFieldValue("tickets", updated);
            return;
        }

        const product = selectedOption.product;
        updated[index] = {
            ...updated[index],
            articleId: product.id || "",
            articleCode: product.code || "",
            articleLibelle: product.libelle || "",
            prixOriginal: product.prixVenteTTC1 ?? "",
            prixPromo:
                updated[index].prixPromo !== "" && updated[index].prixPromo !== null
                    ? updated[index].prixPromo
                    : product.prixVenteTTC1 ?? product.prixVente1 ?? "",
            barcode: product.codeBarre || "",
        };
        setFieldValue("tickets", updated);

        requestAnimationFrame(() => {
            const input = promoPriceRefs.current[index];
            if (input) {
                input.focus();
                input.select();
            }
        });
    };

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">
                    {isPromotionMode ? "Lignes tickets promo" : "Lignes etiquettes"}
                </h5>
                <Button color="primary" size="sm" onClick={handleAddLine}>
                    + Ajouter ligne
                </Button>
            </div>

            <Table bordered responsive>
                <thead>
                    <tr>
                        <th>Article</th>
                        <th>{isPromotionMode ? "Prix normal" : "Prix"}</th>
                        {isPromotionMode && <th>Prix promo</th>}
                        <th>Barcode</th>
                        <th>Qté étiquettes</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {tickets.length === 0 && (
                        <tr>
                            <td colSpan={isPromotionMode ? "6" : "5"} className="text-center text-muted">
                                Aucune ligne ajoutée
                            </td>
                        </tr>
                    )}

                    {tickets.map((line, index) => (
                        <tr key={index}>
                            <td style={{ minWidth: "280px" }}>
                                <Select
                                    options={productOptions}
                                    isLoading={productsLoading}
                                    isClearable
                                    isSearchable
                                    filterOption={filterProductOption}
                                    placeholder="SÃ©lectionner un article"
                                    value={
                                        productOptions.find((option) => option.value === line.articleId) || (
                                            line.articleId
                                                ? {
                                                    value: line.articleId,
                                                    label: line.articleLibelle || line.articleCode || `Article ${line.articleId}`,
                                                    searchText: [
                                                        line.articleCode,
                                                        line.articleLibelle,
                                                        line.barcode,
                                                    ]
                                                        .filter(Boolean)
                                                        .join(" ")
                                                        .toLowerCase(),
                                                    product: {
                                                        id: line.articleId,
                                                        code: line.articleCode,
                                                        libelle: line.articleLibelle,
                                                        prixVenteTTC1: line.prixOriginal,
                                                        codeBarre: line.barcode,
                                                    },
                                                }
                                                : null
                                        )
                                    }
                                    onChange={(selectedOption) => handleProductSelect(index, selectedOption)}
                                    onInputChange={(inputValue, meta) => {
                                        if (meta.action === "input-change" && onProductSearch) {
                                            onProductSearch(inputValue);
                                        }
                                    }}
                                    menuPortalTarget={typeof window !== "undefined" ? document.body : null}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                />
                            </td>
                            

                            <td style={{ minWidth: "120px" }}>
                                <Input
                                    type="number"
                                    step="0.01"
                                    value={line.prixOriginal}
                                    onFocus={(e) => e.target.select()}
                                    onChange={(e) =>
                                        handleChange(index, "prixOriginal", e.target.value)
                                    }
                                />
                            </td>

                            {isPromotionMode && (
                                <td style={{ minWidth: "120px" }}>
                                    <Input
                                        innerRef={(el) => {
                                            promoPriceRefs.current[index] = el;
                                        }}
                                        type="number"
                                        step="0.01"
                                        value={line.prixPromo}
                                        onFocus={(e) => e.target.select()}
                                        onChange={(e) =>
                                            handleChange(index, "prixPromo", e.target.value)
                                        }
                                    />
                                </td>
                            )}

                            <td style={{ minWidth: "180px" }}>
                                <Input
                                    value={line.barcode}
                                    readOnly
                                />
                            </td>

                            

                            <td style={{ minWidth: "100px" }}>
                                <Input
                                    type="number"
                                    min="1"
                                    value={line.quantiteEtiquettes}
                                    onChange={(e) =>
                                        handleChange(index, "quantiteEtiquettes", e.target.value)
                                    }
                                />
                            </td>

                            

                            <td style={{ minWidth: "100px" }}>
                                <Button
                                    color="danger"
                                    size="sm"
                                    onClick={() => handleRemoveLine(index)}
                                >
                                    Supprimer
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default PromotionTicketLines;
